import { render, staticRenderFns } from "./setting-msg.vue?vue&type=template&id=739a11ec&scoped=true&"
import script from "./setting-msg.vue?vue&type=script&lang=js&"
export * from "./setting-msg.vue?vue&type=script&lang=js&"
import style0 from "./setting-msg.vue?vue&type=style&index=0&id=739a11ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a11ec",
  null
  
)

export default component.exports